import { setupSmoothScroll } from "../experience/smooth-scroll";
import { setupReveals } from "../experience/reveals";
import { setupKineticTypography } from "../experience/kinetic-type";
import { setupTopbarExperience } from "../experience/topbar";
import { setupIdleEnhancements } from "../experience/idle-enhancements";
import { setupRouteFade } from "../experience/route-fade";
const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
const finePointer = window.matchMedia("(pointer:fine)");
const root = document.documentElement;
const markReady = () => requestAnimationFrame(() => root.classList.add("experience-ready"));
const mountExperience = () => {
	markReady();
	const cleanups = [
		setupRouteFade(reduced),
		setupSmoothScroll(reduced),
		setupReveals(reduced),
		setupKineticTypography(reduced),
		setupTopbarExperience(),
		setupIdleEnhancements(reduced, finePointer)
	];
	return () => cleanups.reverse().forEach((cleanup) => cleanup());
};
let teardownExperience = mountExperience();
window.addEventListener("pagehide", () => teardownExperience());
window.addEventListener("pageshow", (event) => {
	root.classList.add("experience-ready");
	if ((event as PageTransitionEvent).persisted) teardownExperience = mountExperience();
});